<template>
  <div />
</template>

<script>
export default {
  name:"OperatorStore",
  data () { return {
    operators:[],
    activeDrivers:[],
    allDrivers:[],
    vehicles:[],
    url: `https://fandango-wombat-7897.twil.io/tc_admin?k=${this.$_auid}`,
  }},
  mounted: async function(){
    // this.url = `https://fandango-wombat-7897.twil.io/tc_admin?k=${this.$_auid}`
    this.loadData();

    // Below doesn't work, should find a solution
    // document.addEventListener("focus", () => {
    //   console.log('focus')
    //   this.loadData();
    // });
  },
  destroyed(){

  },
  methods: {
    loadData: async function(){
      console.log('Loading Operator data')
      axios.get(`${this.url}&m=getActiveDrivers`).then(r=>this.activeDrivers = r.data)
      axios.get(`${this.url}&m=getAllDrivers`).then(r=>this.allDrivers = r.data)
      this.getOperators();
      
      axios.get(`${this.url}&m=getActiveVehicles`).then(async r=>{
        this.vehicles = r.data.map(r=>({...r, access:{}}))
        this.vehicles.forEach(async (r, i)=>{
          this.vehicles[i].access = (await axios.get(`${this.url}&m=getVehicleAccess&vid=${r.vehicle_id}`)).data
          console.log(this.vehicles[i])
        }) 
      })
      
    },

    async getOperators(){
      axios.get(`${this.url}&m=getOperators`).then(r=>{this.operators = [];this.$set(this, 'operators' , r.data)})
    },

    // async createOperatorDriver(id, vid, did){
    //   needs to be switced to operatorKey and driverKey
    //   console.log('createOperatorDriver', id, vid, did)
    //   axios.get(`${this.url}&m=createOperatorDriver&id=${id}&vid=${vid}&did=${did}`).then(this.getOperators)
    // },
    
    async deleteOperatorDriver(operatorKey, driverKey){
      axios.get(`${this.url}&m=deleteOperatorDriver&operatorKey=${operatorKey}&driverKey=${driverKey}`).then(this.getOperators)
    },
    
    async deleteOperator(operatorKey){
      axios.get(`${this.url}&m=deleteOperator&operatorKey=${operatorKey}`).then(this.getOperators)
    },
    
    async updateOperator(operatorKey, data){
      data.m = "updateOperatorAccount"
      data.operatorKey = operatorKey
      data.k = this.$_auid
      axios.post(`${this.url}`, data).then(this.getOperators)
    },



    async createOperator(id){
      const r = await axios.get(`${this.url}&m=createOperator&id=${id}`)
      this.getOperators();
    },

    async createOperatorVehicle(operatorKey, vid){
      const r = await axios.get(`${this.url}&m=createOperatorVehicle&operatorKey=${operatorKey}&vid=${vid}`)
      this.getOperators();
    },
    
    async createCredential(operatorKey, vid, badge, pic){
      const driverKey = `driver_${vid}_${badge}`
      const r = await axios.get(`${this.url}&m=createCredential&operatorKey=${operatorKey}&driverKey=${driverKey}&badge=${badge}&pic=${pic}&vid=${vid}`)
      this.getOperators();
    },
    
    driverForID(id){
      return this.allDrivers.filter(r=>r.id===id)
    },
    
    driversForIDs(driverIDsArray){
      const result = [];
      driverIDsArray.forEach(id=>result.push(this.driverForID(id)))
      return result.map(r=>r.length > 0 ? r[0] : undefined )
    },

    driversForOperator(operator){
      const result = []
      Object.keys(operator).forEach(k=>{
        k.startsWith("driver_") ? result.push({id:k, ...operator[k]}) : 1+1
      })
      return result;
    },
    vehiclesForOperator(operator){
      const result = []
      Object.keys(operator).forEach(k=>{
        k.startsWith("vehicle_") ? result.push({id:k, ...operator[k]}) : 1+1
      })
      return result;
    }
  },
  computed: {

  },
  
}
</script>